module.exports = __webpack_public_path__ + "static/media/lt0d0.92968b71.wav";